import React, { Component } from "react";
import { NavLink, Redirect } from "react-router-dom";
import Cookies from "universal-cookie";

import UserOptionsDropdown from "../users/show/UserOptionsDropdown";
import TextInput from "../TextInput";
import FetchResource from "../../utils/fetch_resource";
import { RichUtils } from "draft-js";

export default class SignUp extends Component {
  constructor(props) {
    super(props);
    this.state = {
      email: "",
      full_name: "",
      univ_lookup: null,
      univ_lookup_id: null,
      signup_notes: "",
      password: "",
      password_confirmation: "",
      university_opts: [],
      data_ready: false,
      notice_message: "",
      display_error: false,
      errors: [],
      display_success: false,
      _isMounted: false,
    };
  }

  componentDidMount = () => {
    this.state._isMounted = true;
    FetchResource(process.env.API_URL + "get_univ", "", this);
  };

  componentWillUnmount = () => {
    this.state._isMounted = false;
  };

  // build parameters to send to the signup(create) user action
  buildUserParams = () => {
    const params = {
      user: {
        email: this.state.email,
        full_name: this.state.full_name,
        univ_lookup_id: this.state.univ_lookup_id,
        univ_lookup: this.state.univ_lookup,
        signup_notes: this.state.signup_notes,
        password: this.state.password,
        password_confirmation: this.state.password_confirmation,
      },
    };

    return JSON.stringify(params);
  };

  handleTextChange = (key, event) => {
    let state = this.state;
    state[key] = event.target.value;
    this.setState(state);
  };

  handleDropdownChange = (options, event) => {
    let { key, ddOpts } = options;
    let optsById = ddOpts.reduce((acc, v) => {
      acc[v.id] = v;
      return acc;
    }, {});
    let selection = optsById[event.target.value];
    let data = {};
    data[key.toString()] = selection;
    if (selection != undefined) {
      this.setState({ univ_lookup_id: data[key].id });
    } else {
      this.setState({ univ_lookup_id: null });
    }
  };

  saveUser = () => {
    return new Promise((resolve, reject) => {
      try {
        fetch(process.env.API_URL + "users", {
          method: "POST",
          body: this.buildUserParams(),
          headers: {
            Accept: "application/json",
            "Content-Type": "application/json",
          },
        }).then((resp) => {
          resp.json().then((data) => {
            resolve(data.token);
            this.setState({ errors: data.errors });
          });
        });
      } catch (err) {
        reject(err);
      }
    });
  };

  successNotification = () => {
    if (this.state.display_success == true) {
      return (
        <div className="row">
          <div className="col-12 text-center">
            <div className="alert alert-success">
              <h3>Signup successful! Please check email.</h3>
            </div>
          </div>
        </div>
      );
    }
  };

  submitUser = (e) => {
    e.preventDefault();
    this.signupValidation();
    this.saveUser()
      .then((token) => {
        const cookies = new Cookies();
        cookies.set("user_session", token.token, { path: "/" });
        this.setState({ display_success: true });
        console.log("display success", this.state.display_success);
        setTimeout(() => {
          this.props.history.push({
            pathname: "/",
          });
        }, 5000);
      })
      .catch((err) => {
        if (this.state._isMounted) {
          this.setState({ display_error: true });
        }
      });
  };

  handleChange = (e, attribute) => {
    const clonedState = Object.assign({}, this.state);
    clonedState[attribute] = e.target.value;
    this.setState(clonedState);
  };

  // validateEmail = (email) => {
  //   let re = /\S+@\S+\.\S+/;
  //   return re.test(email);
  // };

  signupValidation = () => {
    let errors = [];
    const names = {
      email: "Email",
      full_name: "Full name",
      univ_lookup_id: "University",
      password: "Password",
      password_confirmation: "Password Confirmation",
    };
    if (this.state.errors) {
      for (const [key, value] of Object.entries(this.state.errors)) {
        const name = names[key] || key;

        errors.push(`${name}: ${value}`);
      }
    }
    if (errors.length > 0 && this.state.display_error == true) {
      return (
        <div className="row">
          <div className="col-12 text-center">
            <ul className="alert alert-danger">
              {errors.map((e) => (
                <li key={e}>{e}</li>
              ))}
            </ul>
          </div>
        </div>
      );
    } else {
      return <div />;
    }
  };

  // signupValidation = () => {
  //   this.getErrors();
  //   if (this.state.errors != undefined) {
  //     let errors = [];
  //     if (
  //       this.state.errors.email != undefined &&
  //       this.state.errors.email.includes("can't be blank")
  //     ) {
  //       errors.push("Please add your email address");
  //     }
  //     if (
  //       this.state.errors.email != undefined &&
  //       this.state.errors.email.includes("is invalid")
  //     ) {
  //       errors.push("Invalid email address");
  //     }
  //     if (
  //       this.state.errors.email != undefined &&
  //       this.state.errors.email.includes("has already been taken")
  //     ) {
  //       errors.push("Email is already in use");
  //     }
  //     if (this.state.errors.full_name == "can't be blank") {
  //       errors.push("Please add full name");
  //     }
  //     if (this.state.errors.univ_lookup_id == "can't be blank") {
  //       errors.push("Please select a university");
  //     }
  //     if (
  //       this.state.errors.password != undefined &&
  //       this.state.errors.password.includes("can't be blank")
  //     ) {
  //       errors.push("Please enter a password");
  //     }
  //     if (
  //       this.state.errors.password != undefined &&
  //       this.state.errors.password.includes(
  //         "is too short (minimum is 8 characters)"
  //       )
  //     ) {
  //       errors.push("Password must be 8 characters");
  //     }
  //     if (
  //       this.state.errors.password_confirmation != undefined &&
  //       this.state.errors.password_confirmation.includes("can't be blank")
  //     ) {
  //       errors.push("Please confirm password");
  //     }
  //     if (
  //       this.state.errors.password_confirmation != undefined &&
  //       this.state.errors.password_confirmation.includes(
  //         "doesn't match Password"
  //       )
  //     ) {
  //       errors.push("Password and password confirmation must match");
  //     }

  //     if (errors.length > 0 && this.state.display_error == true) {
  //       return (
  //         <div className="row">
  //           <div className="col-12 text-center">
  //             <ul className="alert alert-danger">
  //               {errors.map((e) => (
  //                 <li key={e}>{e}</li>
  //               ))}
  //             </ul>
  //           </div>
  //         </div>
  //       );
  //     } else {
  //       return <div />;
  //     }
  //   }
  // };

  render() {
    return (
      <div className="container">
        {this.signupValidation()}
        {this.successNotification()}
        <div className="row">
          <div className="col-12 text-center mt-5">
            <h1>Sign Up</h1>
            <p style={{ color: "red" }}>Please check email after sign up</p>
          </div>
        </div>
        <div className="d-flex flex-row justify-content-center mt-5">
          <div className="col-6 text-center">
            <div className="card">
              <form className="form p-3">
                <TextInput
                  valText={this.state.email}
                  editMode={true}
                  fieldName="email"
                  labelText="Email:"
                  handleChange={this.handleTextChange}
                />
                <TextInput
                  valText={this.state.full_name}
                  editMode={true}
                  fieldName="full_name"
                  labelText="Full Name:"
                  handleChange={this.handleTextChange}
                />
                <UserOptionsDropdown
                  label="University:"
                  dropDownVal={this.state.univ_lookup_id}
                  options={this.state.university_opts}
                  lookupType="univ_lookup"
                  editMode={true}
                  handleChange={this.handleDropdownChange}
                />
                <fieldset>
                  <TextInput
                    valText={this.state.password}
                    inputType="password"
                    editMode={true}
                    fieldName="password"
                    labelText="Create Password:"
                    handleChange={this.handleTextChange}
                  />
                  <TextInput
                    valText={this.state.password_confirmation}
                    inputType="password"
                    compareVal={this.state.password}
                    editMode={true}
                    fieldName="password_confirmation"
                    labelText="Password Confirmation:"
                    handleChange={this.handleTextChange}
                  />
                </fieldset>

                <div className="form-group">
                  <button
                    onClick={(e) => {
                      this.submitUser(e);
                    }}
                    className="btn btn-primary"
                  >
                    Sign Up
                  </button>
                </div>
              </form>
              <div>
                {/* Opts: should be here:{" "}
                {JSON.stringify(this.state.university_opts)}{" "}
                {JSON.stringify(this.state._isMounted)} */}
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  }
}
